import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const Modal = ({ children, onClose, title, className }) => {
    const modalRef = useRef(null);
    const previousFocusRef = useRef(null);

    useEffect(() => {
        // Save the element that had focus before the modal opened
        previousFocusRef.current = document.activeElement;

        // Focus the modal so keyboard users start inside it
        modalRef.current?.focus();

        // Restore focus to the trigger element when the modal closes
        return () => {
            previousFocusRef.current?.focus();
        };
    }, []);

    const handleOverlayClick = e => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    const handleKeyDown = e => {
        if (e.key === 'Escape') {
            onClose();
        }
    };

    return (
        <div className="modal-overlay" onClick={handleOverlayClick}>
            <div
                ref={modalRef}
                className={`modal-content${className ? ` ${className}` : ''}`}
                role="dialog"
                aria-modal="true"
                aria-label={title}
                tabIndex={-1}
                onKeyDown={handleKeyDown}
            >
                <button className="close-button" onClick={onClose} aria-label="Close">
                    ×
                </button>
                {children}
            </div>
        </div>
    );
};

Modal.propTypes = {
    children: PropTypes.node.isRequired,
    onClose: PropTypes.func.isRequired,
    title: PropTypes.string,
    className: PropTypes.string,
};

Modal.defaultProps = {
    title: 'Dialog',
};

export default Modal;
